import { render } from "./SSRDocumentsView.vue?vue&type=template&id=7e0d6e9c"
import script from "./SSRDocumentsView.vue?vue&type=script&lang=js"
export * from "./SSRDocumentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__